import { Injectable } from '@angular/core';

import { EventModel } from '@frontend/sports/betting-offer/feature/model';
import { NOT_APPLICABLE, TrackData, TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

export enum FeatureTab {
    Scoreboard = 1,
    Video = 2,
    Simulation = 3,
    Statistics = 4,
}

@Injectable({
    providedIn: 'root',
})
export class ScoreboardMediaTrackingService {
    private actionEventByHeaderNavTabs = {
        [FeatureTab.Scoreboard]: 'Score Icon-Click',
        [FeatureTab.Statistics]: 'Stats Icon - Click',
        [FeatureTab.Simulation]: 'Animation Icon - Click',
        [FeatureTab.Video]: 'Video Icon - Click',
    };

    constructor(private trackingService: TrackingService) {}

    trackTabsInteractionForHeader(eventActiveId: FeatureTab, event: EventModel): void {
        this.trackTabsInteraction(event, this.actionEventByHeaderNavTabs[eventActiveId], eventActiveId === FeatureTab.Video);
    }

    trackScoreboardMessageList(isExpanded: boolean, event: EventModel): void {
        if (!event) {
            return;
        }
        const trackData = this.getTrackData(event);
        //@ts-ignore allow dynamic accessor object append
        trackData[trackingConstants.COMPONENT_LABEL_EVENT] = 'Message List';
        //@ts-ignore allow dynamic accessor object append
        trackData[trackingConstants.COMPONENT_ACTION_EVENT] = isExpanded ? 'Expand - Click' : 'Collapse - Click';
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackData);
    }

    private trackTabsInteraction(event: EventModel, actionEvent: string, isVideoTab: boolean): void {
        if (!event) {
            return;
        }
        const trackData = this.getTrackData(event);
        //@ts-ignore allow dynamic accessor object append
        trackData[trackingConstants.COMPONENT_LABEL_EVENT] = 'Tabs Interactions';
        //@ts-ignore allow dynamic accessor object append
        trackData[trackingConstants.COMPONENT_ACTION_EVENT] = actionEvent;
        if (isVideoTab) {
            //@ts-ignore allow dynamic accessor object append
            trackData[trackingConstants.COMPONENT_POSITION_EVENT] = 'Scoreboard Play Button';
        }
        this.trackingService.track(trackingConstants.EVENT_TRACKING, trackData);
    }

    private getTrackData(event: EventModel): TrackData {
        return {
            [trackingConstants.COMPONENT_CATEGORY_EVENT]: 'Scoreboard',
            [trackingConstants.COMPONENT_LABEL_EVENT]: '',
            [trackingConstants.COMPONENT_ACTION_EVENT]: '',
            [trackingConstants.COMPONENT_POSITION_EVENT]: event.sport.id.toString(),
            [trackingConstants.COMPONENT_LOCATION_EVENT]: event.live ? `${event.name}-inplay` : `${event.name}-preevent`,
            [trackingConstants.COMPONENT_EVENT_DETAILS]: event.id,
            [trackingConstants.COMPONENT_URL_CLICKED]: NOT_APPLICABLE,
        };
    }
}
